import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const FileErrorIcon = forwardRef<SVGSVGElement, IconProps>(function FileErrorIcon(
  { color = '', width = 12, height = 13, ...rest },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_3836_38184)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.05095 2.45163C1.71722 2.80821 1.52833 3.35481 1.52833 4.10347V8.01187C1.52833 8.29012 1.29813 8.51568 1.01416 8.51568C0.730199 8.51568 0.5 8.29012 0.5 8.01187V4.10347C0.5 3.20328 0.726598 2.37583 1.29308 1.77057C1.8669 1.15749 2.71472 0.851562 3.78407 0.851562H8.21593C9.28528 0.851562 10.1331 1.15749 10.7069 1.77057C11.2734 2.37583 11.5 3.20328 11.5 4.10347V9.59965C11.5 10.4998 11.2734 11.3273 10.7069 11.9326C10.1331 12.5456 9.28528 12.8516 8.21593 12.8516H5.68838C5.40442 12.8516 5.17422 12.626 5.17422 12.3477C5.17422 12.0695 5.40442 11.8439 5.68838 11.8439H8.21593C9.08551 11.8439 9.62264 11.6002 9.94905 11.2515C10.2828 10.8949 10.4717 10.3483 10.4717 9.59965V4.10347C10.4717 3.35481 10.2828 2.80821 9.94905 2.45163C9.62264 2.10289 9.08551 1.8592 8.21593 1.8592H3.78407C2.91449 1.8592 2.37736 2.10289 2.05095 2.45163Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.24646 2.07294C7.53042 2.07294 7.76062 2.2985 7.76062 2.57675V3.79813C7.76062 4.19163 8.09133 4.51568 8.49292 4.51568H9.73938C10.0233 4.51568 10.2535 4.74125 10.2535 5.0195C10.2535 5.29775 10.0233 5.52332 9.73938 5.52332H8.49292C7.5234 5.52332 6.73229 4.74813 6.73229 3.79813V2.57675C6.73229 2.2985 6.96249 2.07294 7.24646 2.07294Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.864971 9.18233C1.06576 8.98558 1.39132 8.98558 1.59211 9.18233L4.3069 11.8425C4.50769 12.0392 4.50769 12.3582 4.3069 12.555C4.1061 12.7517 3.78055 12.7517 3.57976 12.555L0.864971 9.89484C0.664177 9.69808 0.664177 9.37909 0.864971 9.18233Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.27949 9.20923C4.48028 9.40598 4.48028 9.72498 4.27949 9.92173L1.5647 12.5819C1.36391 12.7786 1.03836 12.7786 0.837564 12.5819C0.63677 12.3851 0.63677 12.0661 0.837564 11.8694L3.55235 9.20923C3.75314 9.01248 4.0787 9.01248 4.27949 9.20923Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_3836_38184">
          <rect width="12" height="12" fill="white" transform="translate(0 0.851562)" />
        </clipPath>
      </defs>
    </svg>
  );
});
